import axios from 'axios'
import isArray from 'lodash/isArray'
import has from 'lodash/has'
import { getToken,removeToken } from '@/utils/auth'
import { ElMessage } from 'element-plus'
// import {useStore} from 'vuex'

// const store = useStore()
import store from '@/store'
import {computed} from "vue";

const createInstance = () => {
  const instance = axios.create({
    timeout: 30000,
    withCredentials: true,
  })

  instance.interceptors.request.use(config => {
    if (getToken()) {
      config.headers['token'] = getToken()
    }
    const lang = computed(() => store.state.user.language)
    // zh_CN NTD

    config.headers['lang'] = lang.value == 'zh-CN' ? 'zh_CN' : 'zh_TW'
    config.headers['from'] = 'web'

    config.url = '/api' + config.url
    return config
  })

  // 让使用者拿到数据而非原始响应
  instance.interceptors.response.use(
    response => {
      return response
    },
    error => {
      return Promise.reject(error)
    },
  )
  return instance
}

const createApiClient = () => ({
  instance: createInstance(),
  errorMiddleware: null,
  retryUrl: null,
  promiseCache: {},
  get(url: string, params: any = {}, options = {}): Promise<any> {
    // console.log('options', options);
    return this.request('get', url, null, options, params)
  },
  put(url: string, data?: any, options = {}): Promise<any> {
    return this.request('put', url, data, options)
  },
  post(url: string, data = {}, options = {}): Promise<any> {
    return this.request('post', url, data, options)
  },
  patch(url: string, data: any, options = {}): Promise<any> {
    return this.request('patch', url, data, options)
  },
  delete(url: string, data: any = {}, options = {}): Promise<any> {
    return this.request('delete', url, data, options)
  },
  upload(url: string, data: any, files: any[], options = {}): Promise<any> {
    if (isArray(files)) {
      files = files.map((file: any) => ({name: 'source', data: file}))
    } else {
      files = [{name: 'source', data: files}]
    }

    const formData = new FormData()
    files.forEach(file => formData.append(file.name, file.data))
    data.forEach((value: any, key: string) => formData.append(key, value))

    return this.post(url, formData, {...options, forbidReuse: true, timeout: 60000})
  },
  request(method: string, url: string, data: any, options = {}, params?:any): Promise<any> {

    const param: any = {method, url, data, ...options, params}
    const promise: Promise<any> = this.instance
      .request(param)
      .then(response => {
        const urls = ['/collect/check_collect']
        const includes = urls.some(substring => response.request.responseURL.includes(substring));
        if (has(response.data, 'code') && response.data.code !== 0) {
          if (includes) {
            return this.handleSuccess(url, method, response)
          } else {
            // ElMessage.error(response.data.msg)
            return Promise.reject({response: {data: response.data.msg, code: response.data.code}})
          }

        } else {
          return this.handleSuccess(url, method, response)
        }
        // return this.handleSuccess(url, method, response)
      })
      .catch(error => {
        console.log('catch',error);
        return this.handleError(url, method, data, options, error)
      })

    return promise
  },
  handleError(url: string, method: string, data: any, options: any, error: any): Promise<any> | void {
    const responseError = error && error.response && error.response.data
    const responseStatus = error && error.response && error.response.status
    const responseCode = error && error.response && error.response.code
    console.log('handleError', responseCode, error);
    if (responseCode==301) {
      // ElMessage.error(responseError)
      localStorage.clear()
      removeToken()
      // location.replace('/')
      store.dispatch('user/setRemoveToken', true)
      if (!options?.noLoginModal) {
        store.dispatch('user/setLoginShow', true)
      }
    } else if (responseCode==1) {
      if(!options.noErrMsg){
        ElMessage.error(responseError)
      }
      return Promise.resolve({
        code: 1,
        data: error.response.data
      })
    } else if (responseCode==-3) {
      return Promise.resolve(error.response)
    } else if (responseCode==-2) {
      ElMessage.error(responseError)
      return Promise.resolve(error.response)
    }else if (responseError) {
      ElMessage.error(responseError)
      return Promise.resolve(error.response)
    }
  },
  handleSuccess(url: string, method: string, response: any): Promise<any> {
    // console.log('response-handleSuccess', response.data);

    if (response.data && response.data.msg && response.data.msg === 'success') {
      return Promise.resolve(response.data)
    } else {
      return Promise.resolve(response)
    }
  },
  // 设置参数
  setBaseUrl(baseURL: string): void {
    this.instance.defaults.baseURL = baseURL
  },
  setToken(token: string | null): void {
    this.instance.defaults.headers.common['Authorization'] = token
  },
  delToken(): void {
    this.instance.defaults.headers.common['Authorization'] = ''
  },
})

const ApiClient = createApiClient()
ApiClient.setBaseUrl(process.env.VUE_APP_BASE_URL as string)

// 创建一个不需要token的http请求
export const noTokenApiClient = createApiClient()
noTokenApiClient.instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  },
)

export default ApiClient
